import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import CloseIcon from '@mui/icons-material/Close'
import { Alert, IconButton } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { finishInfoAlert } from 'redux/alert/alert-actions'
import { RootState } from 'redux/store'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../../styles'
import { infoImg } from '../../utils'

const AlertInfoComponent = () => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const { infoAlertText, infoAlert } = useSelector((state: RootState) => state.alert)

    const handleClose = () => {
        dispatch(finishInfoAlert())
    }

    return (
        <FadeAnimationDiv>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={formTheme}>
                    <Collapse in={infoAlert} timeout={500}>
                        <Alert
                            icon={false}
                            className="info"
                            action={
                                <IconButton className="alertDismiss" aria-label="close" color="inherit" size="small" onClick={handleClose}>
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            <div className="iconBox">
                                <img className="iconImg" src={infoImg} alt={t('Alert.Info')} />
                            </div>
                            <div className="message">
                                <span className="textWrap">
                                    <span className="type">{t('Alert.Info')}:</span>
                                    <span className="text">{infoAlertText}</span>
                                </span>
                            </div>
                        </Alert>
                    </Collapse>
                </ThemeProvider>
            </StyledEngineProvider>
        </FadeAnimationDiv>
    )
}

export default AlertInfoComponent
